const deliStatus = [
    { value: "none", name: "None" },
    { value: "refund", name: "Refunded" },
    { value: "error", name: "Error" },
    { value: "delivered", name: "Delivered" },
    { value: "undelivered", name: "Undelivered" },
    { value: "case_item", name: "Case item not received" },
    { value: "case_des", name: "Case not as described" },
    { value: "fraudulent", name: "Fraudulent" },
    { value: "case_other", name: "Case Khác" },
    { value: "cancelled", name: "Cancelled" },
]
export default deliStatus
